module.exports = __webpack_public_path__ + "img/eiac_logo.f879f540.png";